import "./AboutUs.css"
import React, { useContext, useState, useEffect } from 'react'
import { LanguageContext } from '../Language/LanguageContext'
import { updateContent, getContent, viewAbout, editAbout } from '../Network/Content'
import { NotifyContext } from '../Library/Notify'
import SunEditor  from 'suneditor-react'
import { Button } from 'react-bootstrap'
import { Container, Loading, HeaderTitle } from '../Library'
import { setDocumentTitle } from '../AppTitle'
import 'suneditor/dist/css/suneditor.min.css'

function AboutUs() {
    const [isLoading, setLoading] = useState(false)
    const notify = useContext(NotifyContext)
    const contentId = 3
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.content
    const [originalContent, setOriginalContent] = useState("");
    const [content, setContent] = useState("");

    useEffect(()=>{
        setDocumentTitle("About US")
        const fetchData = () =>{
            setLoading(true)
            viewAbout(
                (about)=>{ 
                    setContent(about) 
                    setOriginalContent(about)
                    setLoading(false)
                },
                (error)=>{
                    setLoading(false)
                    notify.showNotify("Something wrong", error.message, 2)
                }
            )
        }
        fetchData()

        function closeListener(e){
            e.preventDefault()
            e.returnValue = lang.changed_alert
            return lang.changed_alert
        }

        window.addEventListener("beforeunload", closeListener)

        return () =>{
            window.removeEventListener("beforeunload", closeListener)
        }
    },[])

    const updateAboutUs = () =>{
        setLoading(true)
        // updateContent(contentId, content,
        //     ()=>{
        //         notify.showNotify(lang.about_us_success, lang.about_us_success_desc, 0)
        //         setLoading(false)
        //     },
        //     (error)=>{
        //         notify.showNotify("Something wrong", error.message, 2)
        //         setLoading(false)
        //     })
        editAbout(content,
            (about)=>{
                notify.showNotify(lang.about_us_success, lang.about_us_success_desc, 0)
                setOriginalContent(about)
                setLoading(false)
            },
            (error)=>{
                notify.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            })
    }
   
    return (
        <Container topbarTitle={langCx.lang.sidebar.about_us}>
        { isLoading ? <Loading/> : null}
        <div id="about_us">
            <HeaderTitle 
            title={lang.edit_about_us}
            customRight={
                <>
                { originalContent !== content ?
                <div className="content-change">
                    <div className="indicator"></div>
                    <span>{lang.content_change}</span>
                </div>
                : null
                }
                </>
            }
            />
            
            <div className ="editor">
                <SunEditor width="100%" height="500" setOptions={{
                    buttonList: [
                        ['undo', 'redo'],
                        ['font', 'fontSize', 'formatBlock'],
                        ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                        ['fontColor', 'hiliteColor'],
                        ['outdent', 'indent'],
                        ['align', 'horizontalRule', 'list', 'lineHeight'],
                        ['table', 'link'],
                        ['fullScreen', 'showBlocks'],
                    ]
			    }} 
                setContents={content}
                onChange={setContent}
                />
            </div>
            <hr/>
            <Button className="edit-btn" 
            onClick={()=>updateAboutUs()}>
                {lang.save_change}
            </Button>
        </div>
        </Container>
    )
}

export default AboutUs